import { render, staticRenderFns } from "./SpeakerAvatar.vue?vue&type=template&id=0e0802c1&scoped=true"
import script from "./SpeakerAvatar.vue?vue&type=script&lang=js"
export * from "./SpeakerAvatar.vue?vue&type=script&lang=js"
import style0 from "./SpeakerAvatar.vue?vue&type=style&index=0&id=0e0802c1&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "0e0802c1",
  null
  
)

export default component.exports